import getNodeName from "./getNodeName.js";
export default function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}


//////////////////
// WEBPACK FOOTER
// /srv/www/fleet/wp-content/themes/fmti/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
// module id = 62
// module chunks = 0